module.exports = __webpack_public_path__ + "img/1.5aed0f5e.png";